module.exports = __webpack_public_path__ + "static/media/02_christian_stemmler_cornelius_carstens.6f16ff2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/stemmi/02_christian_stemmler_cornelius_carstens.mp4
// module id = ooQX
// module chunks = 1